import { render, staticRenderFns } from "./HistoryPersonContact.vue?vue&type=template&id=697caa64"
import script from "./HistoryPersonContact.vue?vue&type=script&lang=js"
export * from "./HistoryPersonContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports